import GeneralBookingFormCrm from "./_GeneralBookingFormCrm";

export default class HospitalBooking extends GeneralBookingFormCrm {
  constructor({ managers, dateTimeManager } = {}) {
    super({
      managers,
      dateTimeManager,
      formSelector: "#the-hospital-booking-form",
      formType: "hospital",
    });
  }

  initRelationData() {
    if (!hospitalBookingFormVars?.hospital) {
      return;
    }

    const hospital = hospitalBookingFormVars.hospital;
    const $form = this.$form;
    const $hospitalsSelect = $form.find("#hospitals-select-list");
    const $hospitalsInput = $form.find("input[name='booking-hospital']");
    const hospitalSubmissionId = hospital.hospital_id;

    $hospitalsInput.val(hospitalSubmissionId);

    const $hospitalsCustomSelect = $hospitalsSelect.closest(".custom-select");
    $hospitalsCustomSelect
      .find(".current-value")
      .html(hospital.title)
      .removeClass("default-value");

    const shortName = hospital.hospital_shortname || "";
    $hospitalsSelect.html(
      `<li class="option active" data-value="${hospitalSubmissionId}" data-hospital="${shortName}">${hospital.title}</li>`
    );

    $hospitalsCustomSelect.css({
      "pointer-events": "none",
      opacity: "0.7",
    });

    this.handleHospitalSelection(hospital);

    $form
      .find('input[name="phone"]')
      .on("input.otpPhoneChange change.otpPhoneChange", () => {
        this.clearOtpVerificationToken();
      });
  }

  resetCustomSelects() {
    super.resetCustomSelects();
    this.initRelationData();
  }
}
